import styled, { css } from 'styled-components';
import { Typography } from '../Typography/Typography';

const neutralBadgeStyles = css`
  color: var(--grayscale-900);
  background: var(--surface-200);
`;

const successBadgeStyles = css`
  color: var(--green-800);
  // TODO(tokens): add this to the design system?
  // TODO(tokens): Replace hex color value #c7eac7 with numbered equivalent once available.
  background: #c7eac7;
`;

const warningBadgeStyles = css`
  // TODO(tokens): Replace legacy color token --dark-yellow with numbered equivalent once available.
  color: var(--dark-yellow);
  background: var(--yellow-100);
`;

const errorBadgeStyles = css`
  color: var(--red-800);
  // TODO(tokens): Replace legacy color token --extra-light-red with numbered equivalent once available.
  background: var(--extra-light-red);
`;

const primaryBadgeStyles = css`
  color: var(--grayscale-900);
  background: var(--purple-200);
`;

const badgeVariants = ['neutral', 'success', 'warning', 'error', 'primary'] as const;
export type BadgeVariant = (typeof badgeVariants)[number];

const badgeVariantStyles = {
  neutral: neutralBadgeStyles,
  success: successBadgeStyles,
  warning: warningBadgeStyles,
  error: errorBadgeStyles,
  primary: primaryBadgeStyles,
};

const StyledBadge = styled.div<{ $variant: BadgeVariant; $slim?: boolean }>`
  width: fit-content;
  padding: ${({ $slim }) => ($slim ? '3px 8px' : '4px 8px')};
  border-radius: var(--border-radius-large);
  // transparent border so the shape is visible on windows high contrast mode,
  // which removes decorative styles like background color but makes all borders
  // 100% opacity black
  border: 1px solid rgba(0, 0, 0, 0);

  ${({ $variant }) => badgeVariantStyles[$variant]}
`;

export type BadgeProps = {
  variant: BadgeVariant;
  slim?: boolean;
  children: React.ReactNode;
};

/**
 * A pill-shaped badge for displaying a status or a tag.
 */
export const Badge = ({ variant, children, slim }: BadgeProps) => {
  return (
    <StyledBadge $variant={variant} $slim={slim}>
      <Typography styledAs="bodySmallSpaceGrotesk" weight={500}>
        {children}
      </Typography>
    </StyledBadge>
  );
};

export default Badge;
